import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';

const SkeletonTable = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                padding: '20px',
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 2fr)',
                    gap: '20px',
                    borderBottom: '1px solid whitesmoke',
                    paddingBottom: '10px',
                }}
            >
                <Typography variant="h5">
                    <Skeleton width="80px" />
                </Typography>
                <Typography variant="h5">
                    <Skeleton width="100px" />
                </Typography>
                <Typography variant="h5">
                    <Skeleton width="120px" />
                </Typography>
            </Box>

            {/* Rows */}
            {Array.from({ length: 20 }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 2fr)',
                        gap: '20px',
                        padding: '10px 0',
                        borderBottom: '1px solid whitesmoke',
                    }}
                >
                    <Skeleton width="150px" height="30px" />
                    <Skeleton width="100px" height="30px" />
                    <Skeleton width="80px" height="30px" />
                </Box>
            ))}
        </Box>
    );
};

export default SkeletonTable;